module.exports = __webpack_public_path__ + "media/aboutUs.1d2f6697.mp4";